export default __webpack_public_path__ + "34294838b2ca68ccd4cda3326d1cc6e2.svg";